import { Banner } from "@mittwald/flow-components/dist/components/Banner";
import { ColumnLayout } from "@mittwald/flow-components/dist/components/ColumnLayout";
import { TextLink } from "@mittwald/flow-components/dist/components/TextLink";
import type { AnimationController } from "@mittwald/flow-components/dist/hooks/useAnimationController";
import type { FC } from "react";
import React from "react";
import { LoginForm } from "../../../../pages/authorization/login/components/LoginForm";
import config from "../../../config";

export interface LoginStepContentProps {
  rejectionAnimation: AnimationController;
}

export const LoginStepContent: FC<LoginStepContentProps> = (props) => {
  const { rejectionAnimation } = props;

  return (
    <>
      <Banner
        description="loginDescriptionDedicatedServer"
        headline="loginBanner"
      />
      <ColumnLayout medium={[1, 1]}>
        <LoginForm rejectionAnimation={rejectionAnimation} />
      </ColumnLayout>
      <TextLink action={config.passwordResetLink} i18n="password.forgot" />
    </>
  );
};
